// extracted by mini-css-extract-plugin
export default {"fullscreenPage":"ScormPage_fullscreenPage__NcXAK"};